module.exports = __webpack_public_path__ + "static/media/AIcollage2.26a96b31.jpg";